import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import DeleteIcon from 'material-ui-icons/Delete';
import ToPublishIcon from 'material-ui-icons/Publish';
import ToUnpublishIcon from 'material-ui-icons/GetApp';
import IsNotEditedIcon from 'material-ui-icons/VisibilityOff';
import IsEditedIcon from 'material-ui-icons/CheckCircle';
import NotActiveIcon from 'material-ui-icons/Block';
import TranslateIcon from 'material-ui-icons/Translate';
import PageDeleteDialog from './PageDeleteDialog';
import TranslatePageDialog from './PageTranslateDialog';
import UnpublishPageDialog from './PageUnpublishDialog';
import {
    deletePage,
    publishPage,
    unpublishPage,
    fetchExistingPageTranslations,
    createPageClones,
    fetchMissingPageTranslations
} from './thunks';
import {
    selectStatusCode,
    updateRedirectUrl,
    updateTranslationSite,
    clearRedirectUrl,
    clearStatusCode,
    clearTranslationSite,
    updateAddTranslationSites,
    clearAddTranslationSites, selectAllAddTranslationSites
} from './actions';
import {fetchStatuses} from '../redirects/thunks';
import {fetchSites} from '../sites/thunks';
import {
    showEditGlobalButton,
    showDeleteGlobalButton,
} from '../../components/permissions/permissions';

class PagesGridActions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDelete: false,
            openTranslate: false,
            openUnpublish: false,
            pageId: null
        };
    }

    handleClickOpenDelete = (pageId) => {
        this.props.fetchStatuses();
        this.props.clearRedirectUrl();
        this.props.clearStatusCode();
        this.setState({
            openDelete: true,
            pageId: pageId
        });
    };

    handleRequestCloseDelete = () => {
        this.props.clearRedirectUrl();
        this.props.clearStatusCode();
        this.setState({
            openDelete: false,
            pageId: null
        });
    };

    deletePage = () => {
        this.props.deletePage(this.state.pageId, this.props.selectedStatus, this.props.redirectUrl);
        this.setState({
            openDelete: false,
            pageId: null
        });
    };

    publishPage = (pageId) => {
        this.props.publishPage(pageId);
    };

    handleClickOpenUnpublish = (pageId) => {
        this.props.fetchStatuses();
        this.props.clearRedirectUrl();
        this.props.clearStatusCode();
        this.setState({
            openUnpublish: true,
            pageId: pageId
        });
    };

    handleRequestCloseUnpublish = () => {
        this.props.clearRedirectUrl();
        this.props.clearStatusCode();
        this.setState({
            openUnpublish: false,
            pageId: null
        });
    };

    unpublishPage = () => {
        this.props.unpublishPage(this.state.pageId, this.props.selectedStatus, this.props.redirectUrl);
        this.setState({
            openUnpublish: false,
            pageId: null
        });
    };

    handleClickOpenTranslate = (pageId) => {
        this.props.fetchSites();
        this.props.fetchMissingPageTranslations(pageId);
        this.setState({
            openTranslate: true,
            pageId: pageId
        });
    };

    handleRequestCloseTranslate = () => {
        this.props.clearAddTranslationSites();
        this.setState({
            openTranslate: false,
            pageId: null
        });
    };

    translatePage = () => {
        let selectedSites = [];

        this.props.missingPageTranslations.forEach(site => {
            if (site.is_checked) {
                selectedSites.push(site.id);
            }
        });

        if (selectedSites.length > 0) {
            this.props.createPageClones(this.state.pageId, selectedSites);
        }
        this.setState({
            openTranslate: false,
            pageId: null
        });
    };

    render() {
        const {props, pageTypes, loading} = this.props;

        const EditPageButton = showEditGlobalButton(() =>
            <span>
                <Link to={"pages/" + props.row.id}>
                    <Tooltip title="Edit Page">
                        <IconButton className="smallIconButton editColor">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </Link>{' '}
            </span>
        );

        const DeletePageButton = showDeleteGlobalButton(() =>
            <span className="smallIconButtonPages">
                <Tooltip title="Delete Page">
                    <IconButton className="smallIconButtonDelete deleteColor" onClick={() => this.handleClickOpenDelete(props.row.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const PublishPageButton = showEditGlobalButton(() =>
            <span className="smallIconButtonPages">
                <Tooltip title="Page is edited &amp; can be published! Click here to PUBLISH page!" className="cursorDefault">
                    <IconButton className="smallIconButton enableColor" onClick={() => this.publishPage(props.row.id)}>
                        <ToPublishIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const UnpublishPageButton = showEditGlobalButton(() =>
            <span className="smallIconButtonPages">
                <Tooltip title="UNPUBLISH page (page is now live)" className="cursorDefault">
                    <IconButton className="smallIconButton viewColor" onClick={() => this.handleClickOpenUnpublish(props.row.id)}>
                        <ToUnpublishIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const AddPageTranslationButton = showEditGlobalButton(() =>
            <span className="smallIconButtonPages">
                <Tooltip title="Add missing translation for this page" className="cursorDefault">
                    <IconButton className="smallIconButtonNoMaster translatePageColor" onClick={() => this.handleClickOpenTranslate(props.row.id)}>
                        <TranslateIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const notActivePageIcon = (
            <span className="marginRight3px">
                <Tooltip title="Please edit Master page for this page type first!" className="cursorDefault">
                    <IconButton className="smallIconButtonNoMaster deleteColor cursorDefault">
                        <NotActiveIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const notEditedPageIcon = (
            <span className="smallIconButtonPages">
                <Tooltip title="Page is not edited &amp; cannot be published!" className="cursorDefault">
                    <IconButton className="smallIconButtonNotEdited disableColor cursorDefault">
                        <IsNotEditedIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const notEditedMasterPageIcon = (
            <span className="smallIconButtonPages">
                <Tooltip title="Mandatory fields have NOT been edited!" className="cursorDefault">
                    <IconButton className="smallIconButtonNotEdited deleteColor cursorDefault">
                        <NotActiveIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        const isEditedMasterPageIcon = (
            <span className="smallIconButtonPages">
                <Tooltip title="Mandatory fields have been edited!" className="cursorDefault">
                    <IconButton className="smallIconButtonNotEdited enableColor cursorDefault">
                        <IsEditedIcon />
                    </IconButton>
                </Tooltip>
            </span>
        );

        let canDeletePageType;

        pageTypes.map(pageType => {
            if (pageType.id === props.row.type_id) {
                canDeletePageType = pageType.can_delete === "1" ? true : false;
            }
            return canDeletePageType;
        })

        let isMaster = props.original.master === null;
        let masterIsEdited = isMaster && props.original.url !== null;
        let isReview = props.row.type_id === 14;
        let editedPage = props.original.url !== null ? true : false;
        let notEditedPage = (!editedPage && !isMaster) || (!editedPage && isReview) ? true : false;
        let canEditPage = !isMaster && props.original.master.url !== null ? true : false;
        let canPublishPage = editedPage ? true : false;
        let isPublished = props.original.published === 1;
        let hasAllTranslations = !props.original.has_missing_translations;

        return(
            <span>
                {canEditPage || isMaster ? <EditPageButton /> : notActivePageIcon}

                {!hasAllTranslations && <AddPageTranslationButton />}

                {canPublishPage && !isPublished && <PublishPageButton />}

                {isPublished && <UnpublishPageButton />}

                {notEditedPage && notEditedPageIcon}

                {isMaster && !isReview && masterIsEdited && isEditedMasterPageIcon}

                {isMaster && !isReview && !masterIsEdited && notEditedMasterPageIcon}

                {canDeletePageType && <DeletePageButton />}

                {!loading && <TranslatePageDialog
                    open={this.state.openTranslate}
                    pageTitle={props.row.title}
                    pageSiteName={props.original.site}
                    missingPageTranslations={this.props.missingPageTranslations}
                    updateAddTranslationSites={this.props.updateAddTranslationSites}
                    handleSubmit={this.translatePage}
                    handleRequestClose={this.handleRequestCloseTranslate}
                    handleSelectAll={this.props.selectAllAddTranslationSites}
                />}
                {!loading && <UnpublishPageDialog
                    open={this.state.openUnpublish}
                    statuses={this.props.statuses}
                    selectedStatus={this.props.selectedStatus}
                    selectStatusCode={this.props.selectStatusCode}
                    pageTitle={props.row.title}
                    redirectUrl={this.props.redirectUrl}
                    updateRedirectUrl={this.props.updateRedirectUrl}
                    handleSubmit={this.unpublishPage}
                    handleRequestClose={this.handleRequestCloseUnpublish}
                    clearRedirectUrl={this.props.clearRedirectUrl}
                />}
                {!loading && <PageDeleteDialog
                    open={this.state.openDelete}
                    statuses={this.props.statuses}
                    selectedStatus={this.props.selectedStatus}
                    selectStatusCode={this.props.selectStatusCode}
                    isMaster={isMaster}
                    editedPage={editedPage}
                    pageTitle={props.row.title}
                    redirectUrl={this.props.redirectUrl}
                    updateRedirectUrl={this.props.updateRedirectUrl}
                    handleSubmit={this.deletePage}
                    handleRequestClose={this.handleRequestCloseDelete}
                    clearRedirectUrl={this.props.clearRedirectUrl}
                />}
            </span>
        )
    }
}

const mapStateToProps = state => ({
    pageTypes: state.pages.types,
    statuses: state.redirects.statuses,
    selectedStatus: state.pages.selectedStatus,
    redirectUrl: state.pages.redirectUrl,
    sites: state.sites.all,
    missingPageTranslations: state.pages.missingPageTranslations,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    deletePage,
    fetchStatuses,
    selectStatusCode,
    updateRedirectUrl,
    clearRedirectUrl,
    clearStatusCode,
    publishPage,
    unpublishPage,
    fetchSites,
    updateTranslationSite,
    clearTranslationSite,
    createPageClones,
    fetchExistingPageTranslations,
    fetchMissingPageTranslations,
    updateAddTranslationSites,
    clearAddTranslationSites,
    selectAllAddTranslationSites
})(PagesGridActions);


// WEBPACK FOOTER //
// ./src/containers/pages/PagesGridActions.jsx